import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const path = window.location.pathname;
  // Use customer token on customer-facing pages, admin token on admin pages
  let token;
  if (path.startsWith('/admin')) {
    token = localStorage.getItem('sparky_admin_token');
  } else if (path.startsWith('/portal') || path.startsWith('/checkout') || path.startsWith('/upsell')) {
    token = localStorage.getItem('sparky_customer_token') || localStorage.getItem('sparky_admin_token');
  } else {
    token = localStorage.getItem('sparky_admin_token') || localStorage.getItem('sparky_customer_token');
  }
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith('/admin')) {
        localStorage.removeItem('sparky_admin_token');
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
export { API_BASE };
